module.exports = __webpack_public_path__ + "media/application/images/icons/check-circle-white-8694af978ab486d680e5257fead42d64.png";